
export const AUTO_INSIGHTS_HELP = `/learning-center/content/ei_application/dashboards/auto_insights.html`;
